var generic = generic || {};
var site = site || {};

site.template = typeof site.template !== 'undefined' ? site.template : {};

site.template.render =
  typeof site.template.render !== 'undefined'
    ? site.template.render
    : typeof window.Mustache !== 'undefined' && typeof window.Mustache.render !== 'undefined'
    ? window.Mustache.render
    : false;

(function ($) {
  Drupal.behaviors.ELCAdventCalendarFormatterV1 = {
    isMobile: false,
    attached: false,
    $openedTile: $(),
    attach: function (context) {
      var self = this;
      self.$node = $('.adv_cal_cap', context);
      self.$container = $('.js-adv-cal-cap-container', self.$node);

      var bgImageMobile = $('#bg_image_mobile', self.$node).val();
      self.isMobile = self.checkIfMobile();
      if (self.isMobile && bgImageMobile) {
        self.$container.css('background-image', ' url(' + bgImageMobile + ')');
      }
      if (self.attached) {
        return;
      }
      self.attached = true;

      self.$calendarWrapper = $('#adv_cal_cap_wrapper', self.$container);
      self.$cardTemplate = $('#adv_cal_cap_card', self.$container);
      self.toutClass = '.tout';
      self.tileClass = '.tile';
      self.$popupContainer = $('#adv_cal_cap_popup_container', self.$container);
      self.$popup = $(); // will be generated
      self.$errorContainer = $('.error-content-wrapper', self.$container);
      self.$loader = $('.loader', self.$container);
      self.$defaultTile = $('.tile-default', self.$container);
      self.$customTile = self.$defaultTile;
      self.offersCount = parseInt($('#offers_count', self.$container).val()) || 0;
      self.enable_anchor = parseInt(self.$container.data('enable-anchor')) || 0;
      self.promotion_type = 'offer_grid';
      self.offer_image_path = '/media/export/cms/adv_cal/';
      self.translateOffers = self.$container.data('translate-offers');
      self.offers = {};
      self.offersProducts = {};
      self.currentOffer = null;
      self.appliedOffers = {};
      self.count = 0;
      self.tileLabelText = {};
      self.tileImage = {};
      self.tileOfferImageHover = {};
      self.tileVideo = {};
      self.tileVideoLoop = {};
      self.tileText = {};
      self.tileTextHover = {};
      self.tileTextCTA = {};
      self.tileBackgroundColor = {};
      self.tileBackgroundColorHover = {};
      self.tileHeight = {};
      self.tileWidth = {};
      self.tileBorderColor = {};
      self.tileBorderWidth = {};
      self.tileAnimation = {};
      self.tileAnimationHover = {};
      self.tileHoverAnimation = {};
      self.offerTileLink = {};
      self.bps = null;
      self.bp = null;
      self.rpcUrl = null;
      self.init();
    },
    checkIfMobile: function () {
      var self = this;
      var primaryBpSwitch = 768;
      var currentBpWidth;
      var bpMediumUp;
      if (!self.unisonExists()) {
        // If Unison is unavailable then, check for site.client.isMobile
        if (typeof site === 'object' && typeof site.client === 'object') {
          return parseInt(site.client.isMobile, 10) ? true : false;
        }
        //perform the traditional check
        return parseInt($(window).width(), 10) <= primaryBpSwitch;
      }
      currentBpWidth = self.bp ? parseInt(self.bp.width, 10) : undefined;
      bpMediumUp = self.bps ? parseInt(self.bps['medium'], 10) : undefined;
      if (isNaN(bpMediumUp) || isNaN(currentBpWidth)) {
        // If Unison medium bp is not available on any site then, perform the traditional check
        return parseInt($(window).width(), 10) <= primaryBpSwitch;
      }
      return currentBpWidth <= bpMediumUp;
    },
    unisonExists: function () {
      return (typeof Unison !== 'undefined') && Unison;
    },
    setCalendarEvents: function () {
      var self = this;
      $('.active', self.$container)
        .once()
        .on('click', function (e) {
          var $offerTileLink = $('.js-offer-tile-link', $(this));
          if ($offerTileLink.length > 0) {
            return;
          }
          if ($(e.originalEvent.target).hasClass('js-advent-calendar-offer-link')) {
            return;
          }
          e.preventDefault();
          self.resetPopup($(this).data('position'));
          var $offerPanel = $('.js-offer-panel', self.$popup);
          var $videoPanel = $('.js-offer-video', self.$popup);
          var $vidEl = $('.js-offer-video video', self.$popup);
          self.$openedTile = $(this);

          if ($vidEl.length) {
            $offerPanel.addClass('hidden');
            $vidEl.on('loadedmetadata', function () {
              self.setPopupPosition();
              $videoPanel.removeClass('hidden');
            });
            $vidEl.on('ended', function () {
              $('.js-view-offer', self.$popup).trigger('click');
            });
          } else {
            self.setPopupPosition();
            $offerPanel.removeClass('hidden');
            $videoPanel.addClass('hidden');
            self.$openedTile.addClass('opened');
          }
          self.$popup.fadeIn('fast');
        });

      $('.js-anchor-active', self.$container)
        .once()
        .on('click', function () {
          self.scrollActive();
        });

      var timerId;
      $(window).on('resize', function () {
        clearTimeout(timerId);
        timerId = setTimeout(function () {
          if (self.$popup.length && self.$popup.is(':visible') && self.$popup.css('position') !== 'fixed') {
            self.setPopupPosition();
          }
        }, 250);
      });
    },
    setPopupEvents: function () {
      var self = this;
      $('.js-offer-screen', self.$popup).once().on('click', function(e) {
        self.closePopup();
      });
      $(document).on('keydown.adventCalendarOfferClose', function(e) {
        if (e.key === 'Escape') {
          self.closePopup();
        }
      });
      $('.js-apply', self.$popup)
        .once()
        .on('click', function (e) {
          e.preventDefault();
          var link = $(this).data('offer-link');
          self.applyOffer(link);
        });
      $('.js-applied', self.$popup)
        .once()
        .on('click', function (e) {
          e.preventDefault();
          self.removeOffer();
        });
      $('.js-popup-close', self.$popup)
        .once()
        .on('click', function (e) {
          e.preventDefault();
          self.closePopup();
        });
      $('.js-view-offer', self.$popup)
        .once()
        .on('click', function (e) {
          e.preventDefault();
          var $vidEl = $('.js-offer-video video', self.$popup);
          if ($vidEl.length) {
            $vidEl.get(0).pause();
          }
          $('.js-offer-panel', self.$popup).removeClass('hidden');
          $('.js-offer-video', self.$popup).addClass('hidden');
        });
      $('.js-video-replay', self.$popup)
        .once()
        .on('click', function (e) {
          e.preventDefault();
          var pos = self.$popup.data('position');
          var $card = $('.card.p' + pos, self.$container).first();
          if (!!$card.length) {
            $card.trigger('click');
          }
        });
    },
    closePopup: function() {
      var self = this;
      var $vidEl = $('.js-offer-video video', self.$popup);
      if ($vidEl.length) {
        $vidEl.get(0).pause();
      }
      if (self.$openedTile.length) {
        self.$openedTile.removeClass('opened');
      }
      $(document).off('keydown.adventCalendarOfferClose');
      self.$popup.fadeOut();
    },
    getPopupImage: function (offer) {
      var self = this;
      return self.getOfferImage(offer, true);
    },
    getOfferImage: function (offer, isPopup) {
      var self = this;

      if (!!offer.popupImgSrc) {
        return {
          src: offer.popupImgSrc,
          alt: offer.popupImgAlt ? offer.popupImgAlt : ''
        };
      }

      if (self.offerHasSku(offer)) {
        var sku = self.getDefaultSku(offer);
        var product = self.getDefaultProduct(sku);

        return {
          src: product.SMALL_IMAGE,
          alt: product.PROD_RGN_NAME
        };
      }
      if (!offer.image) {
        return;
      }
      var fileGroup = offer.image.split('/').pop().split('.');
      var popupImage = self.offer_image_path + fileGroup[0] + (!!isPopup ? '_popup.' : '.') + fileGroup[1];
      return {
        src: popupImage,
        alt: ''
      };
    },
    setTiles: function (count, timing) {
      var self = this;

      self.$customTile = $('.tile-count__' + count, self.$container);

      self.tileLabelText = self.getTileValue('label-text-' + timing).replace('[NUMBER]', count);
      self.tileImage = self.getTileValue('img-' + timing);
      self.tileOfferImageHover = self.getTileValue('offer-img-' + timing + '-hover');
      self.tileVideo = self.getTileValue('video-' + timing);
      self.tileVideoLoop = self.getTileValue('video-loop-' + timing);
      self.tileText = self.getTileValue('txt-' + timing);
      self.tileTextHover = self.getTileValue('txt-' + timing + '-hover');
      self.tileTextCTAHover = self.getTileValue('txt-' + timing + '-cta-hover');
      self.tileTextHoverAvailable = self.getTileValue('tile-' + timing + '-hover');
      self.tileHeight = self.getTileValue('tile-height');
      self.tileWidth = self.getTileValue('tile-width');
      self.tileRadius = self.getTileValue('tile-radius');
      self.tileBackgroundColor = self.getTileValue('bgcolor-' + timing);
      self.tileBackgroundColorHover = self.getTileValue('bgcolor-' + timing + '-hover');
      self.tileBorderColor = self.getTileValue('bordercolor-' + timing);
      self.tileBorderWidth = self.getTileValue('borderwidth-' + timing);
      self.tileAnimation = self.getTileValue('animation-' + timing);
      self.tileAnimationHover = self.getTileValue('animation-' + timing + '-hover');
      self.tileHoverAnimation = self.getTileValue('hover-animation-' + timing);
      self.offerTileLink = self.getTileValue('offer-tile-link');
    },
    getTileValue: function (dataName) {
      var self = this;
      if (
        self.$customTile.length &&
        self.$customTile.data(dataName) &&
        self.$customTile.data(dataName).toString().trim()
      ) {
        return self.$customTile.data(dataName);
      } else if (
        self.$defaultTile.length &&
        self.$defaultTile.data(dataName) &&
        self.$defaultTile.data(dataName).toString().trim()
      ) {
        return self.$defaultTile.data(dataName);
      }

      return '';
    },
    renderCalendar: function () {
      var self = this;
      var offersIndex = {};
      self.$calendarWrapper.empty();

      for (var key in self.offers) {
        if (self.offers.hasOwnProperty(key)) {
          offersIndex[self.offers[key].sort_order] = self.offers[key];
        }
      }

      self.offersIndex = offersIndex;

      for (var i = 1; i <= self.offersCount; i++) {
        self.count = i;
        if (typeof offersIndex[i] !== 'undefined') {
          var offer = offersIndex[i];

          self.setTiles(self.count, offer.timing);

          offer.popupVideoSrc = self.getTileValue('video-link');
          offer.popupWidth = self.getTileValue('popup-width');
          offer.popupHeight = self.getTileValue('popup-height');
          offer.popupContent = self.getTileValue('popup-content');

          offer.popupBGColor = self.getTileValue('popup-bgcolor');
          offer.popupFGColor = self.getTileValue('popup-fgcolor');
          offer.popupBGColorApplied = self.getTileValue('popup-bgcolor-applied');
          offer.popupFGColorApplied = self.getTileValue('popup-fgcolor-applied');
          offer.popupTextAlign = self.getTileValue('popup-text-align');
          offer.popupBorderRadius = self.getTileValue('popup-border-radius');
          offer.popupCTAPosition = self.getTileValue('cta-position');
          offer.popupCTABGColor = self.getTileValue('cta-bgcolor');
          offer.popupCTAFGColor = self.getTileValue('cta-fgcolor');
          offer.popupCTALetterSpacing = self.getTileValue('cta-letter-spacing');

          offer.popupImgSrc = self.getTileValue('popup-image');
          offer.popupImgAlt = self.getTileValue('popup-image-alt');
          offer.popupViewOffer = self.getTileValue('video-view-offer');
          offer.popupVideoReplay = self.getTileValue('video-replay');
          offer.popupVideoMuted = self.getTileValue('video-muted');
          offer.popupVideoBackgroundColor = self.getTileValue('video-bgcolor');
          offer.popupTandcLabel = self.getTileValue('popup-tandc-label') || 'Terms and Conditions';
          offer.popupTandcLink = self.getTileValue('popup-tandc-link');
          offer.popupOfferApplied = self.getTileValue('popup-offer-applied');
          offer.popupOfferRemoved = self.getTileValue('popup-offer-removed') || 'Offer successfully removed!';
          offer.popupDownloadLinks = [];
          for (var j = 1; j <= 3; j++) {
            var text = self.getTileValue('popup-dl-link' + j + '-txt');
            var url = self.getTileValue('popup-dl-link' + j + '-url');
            if (text !== '' && url !== '') {
              offer.popupDownloadLinks.push({ text: text, url: url });
            }
          }

          self.renderCard(offer);
        } else {
          self.setTiles(i, 'expired');
          self.renderCard();
        }
      }

      self.renderTouts();
      self.setCalendarEvents();
      self.$loader.fadeOut();

      if (self.enable_anchor) {
        setTimeout(function () {
          self.scrollActive();
        }, 1000);
      }
    },
    renderCard: function (offer) {
      var self = this;
      var params = {
        styleattrib: 'style',
        offer_position: self.count,
        offer_timing: 'expired',
        offer_tile_label_text: self.tileLabelText,
        offer_tile_height: self.tileHeight,
        offer_tile_width: self.tileWidth,
        tile_radius: self.tileRadius,
        offer_tile_image: self.tileImage,
        offer_tile_video: self.tileVideo,
        offer_tile_video_loop: self.tileVideoLoop,
        offer_tile_text: self.tileText,
        offer_tile_text_hover: self.tileTextHover,
        offer_tile_text_hover_available: self.tileTextHoverAvailable,
        offer_tile_text_cta_hover: self.tileTextCTAHover,
        offer_tile_position: self.count,
        offer_tile_bgcolor: self.tileBackgroundColor,
        offer_tile_bgcolor_hover: self.tileBackgroundColorHover,
        offer_tile_bordercolor: self.tileBorderColor,
        offer_tile_borderwidth: self.tileBorderWidth,
        offer_tile_animation: self.tileAnimation,
        offer_tile_animation_hover: self.tileAnimationHover,
        offer_tile_hover_animation: self.tileHoverAnimation,
        offer_tile_link: self.offerTileLink
      };

      var rendered;
      offer = offer || false;
      if (offer) {
        var offerImage = self.getOfferImage(offer, false);
        params.offer_image = offerImage.src;
        params.offer_image_alt = offerImage.alt;
        params.offer_image_hover = self.tileOfferImageHover;
        params.offer_timing = offer.timing;
        params.offer_code = offer.offer_code;
      }

      if (!site.template.render) {
        self.showErrorPopup();
        return;
      }

      rendered = site.template.render(self.$cardTemplate.html(), params);
      self.$calendarWrapper.append(rendered);
    },
    renderTouts: function () {
      var self = this;
      $(self.toutClass, self.$container).each(function () {
        var position = parseInt($(this).data('tout-position'));
        var positionBefore = parseInt($(this).data('before-tout-position'));
        var $tout = $(this).clone(true);
        var $tile = $(self.tileClass, self.$calendarWrapper).eq(position - 1);
        var $tileBefore = $(self.tileClass, self.$calendarWrapper).eq(positionBefore - 1);
        if ($tile.length) {
          $tile.after($tout);
        } else {
          $tileBefore.before($tout);
        }
      });
    },
    offerHasSku: function (offer) {
      var self = this;
      return (
        Object.keys(self.offersProducts).length &&
        Object.keys(self.offersProducts.skus).length &&
        self.offersProducts.skus[offer.offer_code] &&
        self.offersProducts.skus[offer.offer_code].length
      );
    },
    getDefaultSku: function (offer) {
      var self = this;
      return self.offersProducts.skus[offer.offer_code][0];
    },
    getDefaultProduct: function (sku) {
      var self = this;
      return self.offersProducts.products[sku.PRODUCT_ID];
    },
    renderPopup: function (offer) {
      var self = this;

      if (typeof offer !== 'undefined' && typeof self.offersIndex[offer] !== 'undefined') {
        self.currentOffer = self.offersIndex[offer];
      }

      var popupImage = self.getPopupImage(self.currentOffer);

      if (!site.template.render) {
        self.showErrorPopup();
        return;
      }

      var rendered = site.template.render(self.$popupContainer.html(), {
        styleattrib: 'style',
        pop_width: self.currentOffer.popupWidth,
        pop_height: self.currentOffer.popupHeight,
        offer_content: self.getOfferContent(self.currentOffer),

        pop_bgcolor: self.currentOffer.popupBGColor,
        pop_fgcolor: self.currentOffer.popupFGColor,
        pop_bgcolor_applied: self.currentOffer.popupBGColorApplied,
        pop_fgcolor_applied: self.currentOffer.popupFGColorApplied,
        pop_border_radius: self.currentOffer.popupBorderRadius,
        pop_cta_position: self.currentOffer.popupCTAPosition,
        pop_cta_bgcolor: self.currentOffer.popupCTABGColor,
        pop_cta_fgcolor: self.currentOffer.popupCTAFGColor,
        pop_text_align: self.currentOffer.popupTextAlign,
        pop_cta_letter_spacing: self.currentOffer.popupCTALetterSpacing,
        pop_image: popupImage.src,
        pop_image_alt: popupImage.alt,
        button_text: self.currentOffer.button_text,
        button_url: self.currentOffer.button_url,
        offer_code: self.currentOffer.offer_code,
        manual: self.currentOffer.activation === 'manual',
        offer_popup_video: self.currentOffer.popupVideoSrc,
        download_links: self.currentOffer.popupDownloadLinks,
        view_offer: self.currentOffer.popupViewOffer,
        video_replay: self.currentOffer.popupVideoReplay,
        video_muted: self.currentOffer.popupVideoMuted,
        video_bgcolor: self.currentOffer.popupVideoBackgroundColor,
        button_text_apply: self.currentOffer.button_text_apply || 'Apply',
        button_text_remove: self.currentOffer.button_text_remove || '',
        tandc: self.currentOffer.popupTandcLink,
        tandc_text: self.currentOffer.popupTandcLabel
      });
      self.$popup.remove();
      self.$popup = $(rendered);
      self.$container.append(self.$popup);
      self.setOfferCTA();
      self.setPopupEvents();
    },
    setPopupPosition: function () {
      var self = this;

      var cssPos = self.$popup.css('position');

      if (cssPos !== 'fixed') {
        var nodeHeight = self.$node.height();
        var windowScrollTop = $(window).scrollTop();

        $('.js-offer-video, .js-offer-panel', self.$popup).each(function () {
          var $panel = $(this);
          var panelHeight = $panel.height();
          var panelTop = windowScrollTop + 15 + panelHeight / 2;

          if (panelTop + panelHeight / 2 > nodeHeight) {
            $panel.css('top', 'auto').css('bottom', 15 - panelHeight / 2 + 'px');
          } else {
            $panel.css('bottom', 'auto').css('top', panelTop + 'px');
          }
        });
      }
    },
    setOfferCTA: function () {
      var self = this;

      var inCart = self.isOfferInCart(self.currentOffer);
      var $applyCTA = $('.js-apply', self.$popup);
      var $removeCTA = $('.js-applied', self.$popup);
      if (!!inCart) {
        $applyCTA.addClass('hidden');
        $removeCTA.removeClass('hidden');
      } else {
        $applyCTA.removeClass('hidden');
        $removeCTA.addClass('hidden');
      }
    },
    getOfferContent: function (offer) {
      var content = offer.popupContent;
      content = content
        .replace('[TITLE]', offer.offer_grid_heading)
        .replace('[SUBTITLE]', offer.offer_grid_subheading)
        .replace('[DESCRIPTION]', offer.offer_grid_description);

      return content;
    },
    isOfferInCart: function (offer) {
      var self = this;
      return typeof self.appliedOffers[offer.offer_code] !== 'undefined' && self.appliedOffers[offer.offer_code];
    },
    getAppliedOffers: function (cb) {
      var self = this;
      var method = 'offer.offersMatching';
      generic.jsonrpc.fetch({
        method: method,
        url: self.rpcUrlForMethod(method),
        params: [
          {
            filter: {
              promotion: self.promotion_type,
              in_cart: 1
            }
          }
        ],
        onSuccess: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getValue();
          if (!!response) {
            self.appliedOffers = {};
            response.forEach(function (el) {
              self.appliedOffers[el.offer_code] = true;
            });
            if (!!cb) {
              cb();
            }
          }
        }
      });
    },
    applyOffer: function (link) {
      var self = this;
      var method = 'offers.apply';
      if (!self.currentOffer) {
        return;
      }
      generic.jsonrpc.fetch({
        method: method,
        url: self.rpcUrlForMethod(method),
        params: [
          {
            offer_code: self.currentOffer.offer_code
          }
        ],
        onBoth: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getValue();
          if (!!response.inCart) {
            var message = !!self.currentOffer.popupOfferApplied
              ? self.currentOffer.popupOfferApplied
              : response.confirm_message || 'Offer successfully applied!';
            self.setMessage(message);
            self.getAppliedOffers(function () {
              self.setOfferCTA();
            });
          } else {
            self.setError(response.error_message);
          }
          if (!!link && link !== '') {
            window.location.href = link;
          }
        }
      });
    },
    removeOffer: function () {
      var self = this;
      var method = 'offer.removeOfferByCode';
      if (!self.currentOffer) {
        return;
      }
      generic.jsonrpc.fetch({
        method: method,
        url: self.rpcUrlForMethod(method),
        params: [
          {
            offer_code: self.currentOffer.offer_code
          }
        ],
        onBoth: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getValue();
          if (response.offer_code) {
            self.setMessage(self.currentOffer.popupOfferRemoved);
            self.getAppliedOffers(function () {
              self.setOfferCTA();
            });
          }
        }
      });
    },
    setMessage: function (message) {
      var self = this;
      var $target = $('.popup-content-wrapper .messages', self.$popup);
      if ($target.length && !!message) {
        $target.html(message).fadeIn('fast').removeClass('warning');
      }
    },
    setError: function (message) {
      var self = this;
      var $target = $('.popup-content-wrapper .messages', self.$popup);
      if ($target.length && !!message) {
        $target.addClass('warning').html(message).fadeIn('fast');
      }
    },
    resetPopup: function (pos) {
      var self = this;
      self.renderPopup(pos);
      self.$popup.data('position', pos);
      var $target = $('.popup-content-wrapper .messages', self.$popup);
      $target.hide();
    },
    scrollActive: function () {
      var self = this;
      if ($('.card.tile.active', self.$calendarWrapper).length) {
        var activeTileTop = $('.card.tile.active', self.$calendarWrapper).first().offset().top;
        var isFixedHeader = $('.js-fixed-header-check', self.$node).css('visibility') === 'visible';
        var headerHeight = isFixedHeader ? self.$node.offset().top : 0;

        $('html, body').animate({ scrollTop: activeTileTop - headerHeight - 10 + 'px' }, 'slow');
      }
    },
    showErrorPopup: function () {
      var self = this;
      var $container = $('.error-content', self.$errorContainer);
      self.$errorContainer.fadeIn().css('display', 'table');
      $(document).mouseup(function (e) {
        if (!$container.is(e.target) && $container.has(e.target).length === 0) {
          self.$errorContainer.fadeOut();
        }
      });
    },
    rpcUrlForMethod: function (method) {
      return this.rpcUrl ? (this.rpcUrl + '?dbgmethod=' + method) : null;
    },
    init: function () {
      var self = this;
      var locale = $.cookie('LOCALE');
      var lang_path;
      var method = 'offers.getOffersRpcData';

      if (self.translateOffers && locale) {
        // self.rpcUrl example: /us/en/rpc/jsonrpc.tmpl
        lang_path = '/' + locale.toLowerCase().split('_').reverse().join('/');
        self.rpcUrl = lang_path + '/rpc/jsonrpc.tmpl';
      }

      if (self.unisonExists()) {
        self.bps = Unison.fetch.all();
        self.bp = Unison.fetch.now();
        Unison.on('change', function() {
          var bgImageMobile = $('#bg_image_mobile', self.$node).val();
          self.bps = Unison.fetch.all();
          self.bp = Unison.fetch.now();
          self.isMobile = self.checkIfMobile();
          if (self.isMobile && bgImageMobile) {
            self.$container.css('background-image', ' url(' + bgImageMobile + ')');
          }
        });
      }

      self.getAppliedOffers();

      generic.jsonrpc.fetch({
        method: method,
        url: self.rpcUrlForMethod(method),
        params: [
          {
            offer_type: self.promotion_type,
            get_products: 1,
            get_messages: 1
          }
        ],
        onSuccess: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getValue();
          if (response && typeof response !== 'undefined' && response.length && Object.keys(response).length) {
            self.showErrorPopup();
            return;
          }
          if (response.offers && typeof response.offers == 'object') {
            self.offers = response.offers;
          }
          if (response.offersProducts && typeof response.offersProducts == 'object') {
            self.offersProducts = response.offersProducts;
          }

          self.renderCalendar();
        },
        onFailure: function () {
          self.showErrorPopup();
        }
      });
    }
  };
})(jQuery);
